import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AuthConfig: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const sessionParam = params.get("session_index");
    const authInstance = params.get("authn_instant");
    const firstNameParam = params.get("firstname");
    const lastNameParam = params.get("lastname");
    const email = params.get("email");
    const groupsParam = params.get("groups");
    const userId = params.get("userid");
    let role: string = "";
    let profiles = [];
    let envGroups = [];
    
    if (groupsParam) {
      const validJson = groupsParam.replace(/'/g, '"');
      try {
        const groupsArray = JSON.parse(validJson);
        role =
          groupsArray.find((group: any) => group.includes("profile_group")) || "";

        envGroups = groupsArray.filter((group: any) => group.includes("env")) || "";

        const rawProfiles = groupsArray.filter(
          (group: any) =>
            !group.includes("profile_group") && !group.includes("env")) 

        profiles = rawProfiles.map((profile: any) =>
          profile.replace("TextSentinel_", "")
        );
      } catch (error) {
        console.error("Error parsing groups JSON:", error);
      }
    }

    if (sessionParam && firstNameParam) {
      try {
        sessionStorage.setItem(
          "sessionData",
          JSON.stringify({
            sessionIndex: sessionParam,
            authInstance: authInstance,
            firstName: firstNameParam,
            lastName: lastNameParam,
            email: email,
            role: role,
            profiles: profiles,
            envGroups: envGroups,
            userId: userId,
          })
        );
        navigate("/welcome");
      } catch (err) {
        console.error("Error parsing auth_result:", err);
      }
    }
  }, [location.search, navigate]);

  return <></>;
};

export default AuthConfig;
